import { render, staticRenderFns } from "./downloadInvitation.vue?vue&type=template&id=5c2bbc16&scoped=true&"
import script from "./downloadInvitation.vue?vue&type=script&lang=js&"
export * from "./downloadInvitation.vue?vue&type=script&lang=js&"
import style0 from "./downloadInvitation.vue?vue&type=style&index=0&id=5c2bbc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2bbc16",
  null
  
)

export default component.exports